/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddDisciplineSubgroupDTO
 */
export interface AddDisciplineSubgroupDTO {
    /**
     * 
     * @type {string}
     * @memberof AddDisciplineSubgroupDTO
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddDisciplineSubgroupDTO
     */
    subjectIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AddDisciplineSubgroupDTO
     */
    groupId?: string;
}

export function AddDisciplineSubgroupDTOFromJSON(json: any): AddDisciplineSubgroupDTO {
    return AddDisciplineSubgroupDTOFromJSONTyped(json, false);
}

export function AddDisciplineSubgroupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddDisciplineSubgroupDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'subjectIds': !exists(json, 'subjectIds') ? undefined : json['subjectIds'],
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
    };
}

export function AddDisciplineSubgroupDTOToJSON(value?: AddDisciplineSubgroupDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'subjectIds': value.subjectIds,
        'groupId': value.groupId,
    };
}

